import { render } from "./RouterLinkAuthWithIcon.vue?vue&type=template&id=5842b12e"
import script from "./RouterLinkAuthWithIcon.vue?vue&type=script&lang=ts"
export * from "./RouterLinkAuthWithIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script